import { T_SHIRT_SIZES } from './T_SHIRT_SIZES';
export var DETAILED_ICON_SIZES = Object.freeze({
  sm: T_SHIRT_SIZES.sm
});